import type { CSSProperties, FC, ReactNode } from 'react'

import { LogoMark } from '@/components/generals/logo'
import { Eyebrow } from '@/components/generals/eyebrow'
import { Container } from '@/components/generals/container'
import { FlowLines } from '@/components/generals/flow-lines'
import { ButtonLink } from '@/components/generals/button'
import { RevealText } from '@/components/generals/reveal-text'

export const ClosingCta: FC = (): ReactNode => {
    return (
        <section
            id='get-started'
            aria-labelledby='closing-cta-title'
            className='relative overflow-hidden bg-burgundy text-cream'
        >
            <div aria-hidden='true' className='pointer-events-none absolute inset-0'>
                <FlowLines tone='light' variant='waves' />

                <LogoMark className='absolute -right-40 top-1/2 size-[640px] -translate-y-1/2 text-cream/[0.035] md:-right-24' />
            </div>

            <Container className='relative py-28 text-center md:py-40'>
                <Eyebrow tone='light'>Get started</Eyebrow>

                <RevealText
                    as='h2'
                    id='closing-cta-title'
                    text='Take control of your financial future.'
                    highlight={['financial future.']}
                    highlightClassName='text-beige'
                    className='mx-auto mt-7 max-w-5xl font-heading text-display-xl font-medium'
                />

                <p
                    data-reveal
                    className='mx-auto mt-7 max-w-xl text-lg leading-relaxed text-cream/70'
                    style={{ '--reveal-delay': '220ms' } as CSSProperties}
                >
                    Spend less time managing numbers and more time making confident decisions.
                </p>

                <div
                    data-reveal
                    className='mt-10 flex flex-col items-center justify-center gap-3 sm:flex-row'
                    style={{ '--reveal-delay': '320ms' } as CSSProperties}
                >
                    <ButtonLink href='/signup' variant='light' size='lg' arrow>
                        Get started
                    </ButtonLink>

                    <ButtonLink href='/demo' variant='outline-light' size='lg'>
                        Request demo
                    </ButtonLink>
                </div>

                <p className='mt-8 text-sm text-cream/50'>
                    14-day free trial on Starter and Growth. No credit card required.
                </p>
            </Container>
        </section>
    )
}
